// @flow
import React, { Component } from 'react';
import OrderTaxTemplateContainer from 'containers/order/OrderTaxTemplateContainer';

type Props = {};

class OrderTax extends Component<Props> {
  render() {
    return <OrderTaxTemplateContainer />;
  }
}

export default OrderTax;



// WEBPACK FOOTER //
// ./src/pages/OrderTax.js